/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonRolesViewModel } from "../types/PersonRolesViewModel.ts";

export const personRolesViewModelSchema = z.object({
  personId: z.optional(
    z.number().int().describe("Identificador único da pessoa."),
  ),
  isStudent: z.optional(
    z.boolean().describe("Indica se a pessoa possui vínculo como aluno."),
  ),
  isMonitor: z.optional(
    z.boolean().describe("Indica se a pessoa possui vínculo como monitor."),
  ),
  isEmployee: z.optional(
    z.boolean().describe("Indica se a pessoa possui vínculo como funcionário."),
  ),
  isTeachingStaff: z.optional(
    z.boolean().describe("Indica se a pessoa faz parte do corpo docente."),
  ),
  isMonitorTCC: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa possui vínculo como monitor de TCC."),
  ),
  isStreamer: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a pessoa possui vínculo como streamer de conteúdo ao vivo.",
      ),
  ),
  isFreelancerMBX: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa possui vínculo como freelancer MBX."),
  ),
  isFreelancerEnglish: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa possui vínculo como freelancer de inglês."),
  ),
  isMonographCoordinator: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a pessoa possui vínculo como coordenador de monografia.",
      ),
  ),
  isMonographAdvisor: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a pessoa possui vínculo como orientador de monografia.",
      ),
  ),
  isMonographOperational: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a pessoa possui vínculo operacional no processo de monografia.",
      ),
  ),
  isBoardMember: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa faz parte do conselho ou diretoria."),
  ),
  isReviewer: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa possui vínculo como revisor de conteúdo."),
  ),
  isExamItemCreator: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a pessoa possui vínculo como criador de itens de prova.",
      ),
  ),
  isExamItemApprover: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a pessoa possui vínculo como aprovador de itens de prova.",
      ),
  ),
  seeOnlyOwnExamItem: z.optional(
    z
      .boolean()
      .describe(
        "Define se a pessoa pode visualizar apenas os itens de prova criados por ela mesma.",
      ),
  ),
  isSeller: z.optional(
    z.boolean().describe("Indica se a pessoa possui vínculo como vendedor."),
  ),
  isSellerManager: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa possui vínculo como gerente de vendas."),
  ),
  isSocialAssistant: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa possui vínculo como assistente social."),
  ),
  isVisitor: z.optional(
    z.boolean().describe("Indica se a pessoa possui vínculo como visitante."),
  ),
  isClassCoordinator: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa possui vínculo como coordenador de turma."),
  ),
  isPolo: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa possui vínculo como polo educacional."),
  ),
  isTest: z.optional(
    z.boolean().describe("Indica se a pessoa é um cadastro de teste."),
  ),
  monographActive: z.optional(
    z
      .boolean()
      .describe("Indica se o vínculo de monografia da pessoa está ativo."),
  ),
}) as unknown as ToZod<PersonRolesViewModel>;
